import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons';
import { iconList } from '@sorare/core/src/atoms/icons/system/iconList.ts';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { BrandXL } from '@sorare/core/src/atoms/typography';

const Title = styled(Vertical)`
  align-items: flex-start;
  gap: var(--double-unit);
`;

export const PublicWatchlistsTitle = ({ count }: { count: number }) => {
  return (
    <Title>
      <FontAwesomeIcon icon={iconList} size="3x" />
      <BrandXL>
        <FormattedMessage
          defaultMessage="{count, plural, one {# Public Watchlist} other {# Public Watchlists}}"
          values={{ count }}
        />
      </BrandXL>
    </Title>
  );
};
